var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 646,
    viewBox: "0 0 642 646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.53 162.252L157.53 323.058L319.376 323.058L319.376 162.252L157.53 162.252Z",
    fill: "url(#paint0_linear_1205_76674)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 485.126L-4 645.939L157.846 645.939L157.846 485.126L-4 485.126Z",
    fill: "url(#paint1_linear_1205_76674)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.77 323.275L318.77 484.088L480.615 484.088L480.615 323.275L318.77 323.275Z",
    fill: "url(#paint2_linear_1205_76674)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.155 -0.000213623L480.155 162.761L642 162.761L642 -0.000211693L480.155 -0.000213623Z",
    fill: "url(#paint3_linear_1205_76674)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.53 323.688L157.53 485.133L-4 323.688L157.53 323.688Z",
    fill: "url(#paint4_linear_1205_76674)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.586 163.21L319.055 163.21L319.055 1.7653L480.586 163.21Z",
    fill: "url(#paint5_linear_1205_76674)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 323.695L157.53 323.695L157.53 162.251L319.06 162.251L319.06 0.806004L-1.00001 0.806C-2.65686 0.806 -4 2.14914 -4 3.806L-4 323.695Z",
    fill: "url(#paint6_linear_1205_76674)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1205_76674",
    x1: 359.616,
    y1: 247.397,
    x2: 242.987,
    y2: 129.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3253EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1205_76674",
    x1: 56.6025,
    y1: 467.018,
    x2: 46.8002,
    y2: 645.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3253EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1205_76674",
    x1: 520.856,
    y1: 408.424,
    x2: 404.221,
    y2: 290.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3253EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1205_76674",
    x1: 682.241,
    y1: 86.1803,
    x2: 564.191,
    y2: -31.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3253EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1205_76674",
    x1: 197.692,
    y1: 409.172,
    x2: 80.5964,
    y2: 291.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3253EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1205_76674",
    x1: 319.213,
    y1: 94.7475,
    x2: 480.817,
    y2: 100.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3253EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1205_76674",
    x1: 156.912,
    y1: 325.668,
    x2: 287.31,
    y2: 65.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3858EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideSquare);
export default __webpack_public_path__ + "static/media/sideSquare.757ae3b5a3815b4d143b6cf5971977a9.svg";
export { ForwardRef as ReactComponent };